<script lang="ts">
  import Pageination from "./components/Pageination.svelte";
  import type { DataSearchResponse } from "./models/data.interface";
  import { fileStore } from "./services/select-files";
  import { showCartAlert } from "./services/cart-service";
  import GenericCollectionDetails from "./components/dataset/dataset-generic/GenericCollectionDetails.svelte";
  import WhenSearchInput from "./components/search/WhenSearchInput.svelte";
  import StationSearchInput from "./components/search/StationSearchInput.svelte";
  import SideSearch from "./components/SideSearch.svelte";
  import { SearchState } from "./services/search-service";
  import MonthSearchInput from "./components/search/MonthSearchInput.svelte";
  // import SelectAllButton from "./components/SelectAllButton.svelte";
  import DataSearchResults from "./components/search/DataSearchResults.svelte";
  import CartAlert from "./components/search/CartAlert.svelte";
  import CartNotification from "./components/search/CartNotification.svelte";
  import OrderOptionsModal from "./components/order/OrderOptionsModal.svelte";
  import CheckboxSearchInput from "./components/search/CheckboxSearchInput.svelte";
  import TooltipHybridButton from "./components/search/TooltipHybridButton.svelte";
  import EverythingSearchInput from "./components/search/EverythingSearchInput.svelte";
  import type { DatasetAggregations } from "./models/dataset.interface";

  const PAGE_SIZE = 20;
  export let searchEndpoint = new URL(process.env.SEARCH_URL);

  const datasetMetadata = JSON.parse(document.getElementById("datasetMetadata").innerHTML);

  let autocompleteUrl = new URL(
    datasetMetadata.ncei.access.search?.station.params.find((p) => p.id == "stations").autocomplete
  );
  let dateFormat = datasetMetadata?.ncei?.access?.search?.when?.params?.dateformat;

  let summaryLoaded: Promise<DatasetAggregations> = fetchSummary(datasetMetadata.id);
  let datasetLoaded: Promise<DataSearchResponse>;

  let datasetSummary: DatasetAggregations;
  let searchResponse: DataSearchResponse;;

  const whenComponentMap = [
    { format: "", component: null },
    { format: "None", component: null },
    { format: "Date", component: WhenSearchInput },
    { format: "DateTime", component: WhenSearchInput },
    { format: "Monthly", component: MonthSearchInput },
    { format: "Month/Day", component: MonthSearchInput },
    { format: "Month/Day/Hour", component: MonthSearchInput }
  ];

  SearchState.subscribe((search) => {
    search.params.set("limit", PAGE_SIZE.toString());
    search.params.set("offset", ((search.pageNum - 1) * PAGE_SIZE).toString());

    datasetLoaded = fetchResults(search.params);
  });

  async function fetchSummary(datasetId: string): Promise<DatasetAggregations> {
    try {
      const response = await fetch(`${searchEndpoint}/v2/datasets/${datasetId}/summary`)
      if (!response.ok) throw new Error("Failed to fetch dataset summary");

      const data = await response.json();
      if (data.aggs) {
        datasetSummary = data.aggs;
      } else {
        throw new Error("Received malformed response when requesting dataset summary")
      }

      return datasetSummary;

    } catch (err) {
      console.error("Error fetching dataset:", err);
      throw err;
    }
  }

  // When files are selected, show the CartAlert
  // $: showCartAlert.set(!!($fileStore.selectedFiles.length > 0));

  async function fetchResults(params: URLSearchParams): Promise<DataSearchResponse> {
    try {
      const response = await fetch(
        // `${searchEndpoint}/v2/datasets/${datasetMetadata.id}?${params}`
        // moving to v1 search for now
        `${searchEndpoint}/v2/datasets/${datasetMetadata.id}?${params}`
      );
      if (!response.ok) throw new Error("Failed to fetch dataset");

      const data: DataSearchResponse = await response.json();
      searchResponse = data;
      return data;
    } catch (err) {
      console.error("Error fetching dataset:", err);
      throw err;
    }
  }

  //$: markers = searchResponse?.results?.map(createMarker) || [];

  // Reuse marker element template
  // const markerTemplate = document.createElement("div");
  // markerTemplate.className = "marker";
  // markerTemplate.style.cssText =
  //   "background-image: url('../icons/marker.svg'); width: 40px; height: 40px; background-size: 100%;";

  // function createMarker(data: DataFile) {
  //   if (!(data?.centroid?.coordinates?.length > 1)) {
  //     console.log("Error: Invalid centroid coordinates found. (Old search data?)");
  //     return;
  //   }
  //
  //   return new Marker(markerTemplate.cloneNode(true) as HTMLElement)
  //     .setLngLat([data.centroid.coordinates[0], data.centroid.coordinates[1]])
  //     .setPopup(
  //       new Popup({ offset: 25 }).setHTML(
  //         `<a href='../station-detail?stationPrefix=${datasetMetadata?.ncei.access.search.station.homrprefix}&stationId=${data.stations[0].id}'>${data.stations[0].name}</a>`
  //       )
  //     );
  // }
</script>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-2 gx-0">

      <!--      dont need data types we only have bulletins-->
      <SideSearch>
        <!--        <CheckboxSearchInput-->
        <!--          title="Data Types"-->
        <!--          slot="datatypes"-->
        <!--          values={JSON.parse(document.getElementById("dataTypes").innerHTML).dataTypes}-->
        <!--          tooltip="<b> Data Types </b> are the elements representing environmental observations in NCEI's data."-->
        <!--          searchUrlQueryParam="dataType"-->
        <!--        />-->
        <!-- dropping where because we have no coordinates -->
        <!--        <LocationSearchInput slot="where" />-->
        <CheckboxSearchInput
          title="Data Format"
          values="{datasetMetadata.ncei.access.search.format.values}"
          searchUrlQueryParam="format"
          tooltip="Select a bulletin data format, ANX(text), PCX(image) or BIN(binary)"
          slot="accessLevel"
        />
        <EverythingSearchInput
          title="WMO Data Designators T1T2A1A2ii"
          placeholder="Ex. SAAF31"
          tooltip="#wmo-heading-tooltip"
          urlparam="headings"
          slot="observationTypes"
        />
        <!--        <CheckboxSearchInput-->
        <!--          title="WMO Data Designators T1T2A1A2ii"-->
        <!--          values={datasetMetadata.ncei.access.search.format.values}-->
        <!--          searchUrlQueryParam="headings"-->
        <!--          tooltip="#wmo-heading-tooltip"-->
        <!--          slot="observationTypes"-->
        <!--        />-->
        <svelte:component
          this={whenComponentMap.find((e) => e.format === dateFormat).component}
          slot="when"
          format={dateFormat}
          enabled={!!dateFormat}
          minDate={datasetSummary?.startDate || '0001-01-01T00:00:00'}
          maxDate={datasetSummary?.endDate || '9999-12-31T23:59:59'}
        />
        <StationSearchInput
          title="WMO CCCC"
          tooltip="#wmo-station-tooltip"
          slot="stations"
          autocompleteUrl={autocompleteUrl}
        />
        <!--        <StationSearchButton slot="button" />-->
      </SideSearch>
    </div>

    <main class="col-md-10">
      {#await datasetLoaded}
        <div class="loading-container">
          <div
            class="spinner-border text-secondary"
            role="status"
            style="width: 3rem; height: 3rem;"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      {:then searchResponse}
        <!-- Title Section -->
        <div class="row dataset">
          <div class="col pt-3 ps-3">
            <h2 style="color: white;">{datasetMetadata?.name}</h2>
            <p style="color: white;" class="lead">
              Browse station files by map or file list, using any search options to narrow down your
              search.
            </p>
          </div>
        </div>

        <!-- Map Section -->
        <div class="row" style="background-color: #F1F3F6;">
          <!--   Dropping the Mapbox for now as results have no centroid coordinates   -->
          <!--          <div class="col-5 px-0">-->
          <!--            <MapComponent arrayPoints={markers || []} mapSize={400} />-->
          <!--          </div>-->
          <div class="col-7 mb-2">
            <div class="pt-3">
              <div>
                <h2>Description</h2>
                <p>{datasetMetadata.ncei.description}</p>
              </div>
            </div>
          </div>
        </div>

        <GenericCollectionDetails resultAggregations={searchResponse?.aggs} datasetAggregations={datasetSummary} />
        <div class="my-4"></div>

        <!-- Results summary and controls -->
        <div class="row">
          <div class="col">
            <div class="d-flex flex-column flex-sm-column flex-md-column flex-lg-row align-items-center justify-content-between mt-2 pb-2">

<!--              <div class="p-2">-->
                <!--              This is going to become something else.-->
                <!--                <SelectAllButton {searchResponse} {searchEndpoint} {datasetMetadata} />-->
                &nbsp;
<!--              </div>-->

                <div class="p-2 d-flex flex-row align-items-center">
                  <span class="px-2">Result Count:</span>
                  <span
                    class:text-danger={searchResponse?.aggs?.count >
                    datasetMetadata?.ncei.access.order?.maxfilecount}
                  >
                    {searchResponse?.aggs?.count}</span>
                  <span class="px-2"> of {datasetSummary?.count}</span>
                </div>
                {#if datasetMetadata?.ncei.access.order}
                <div class="p-2 d-flex flex-row align-items-center">
                  <div class:text-danger={searchResponse?.aggs?.count >
                    datasetMetadata?.ncei.access.order?.maxfilecount}>Order Limit: {datasetMetadata?.ncei.access.order?.maxfilecount}
                  </div>
                  <TooltipHybridButton
                    searchUrlQueryParam="resultCountAndLimit"
                    tooltip="#result-count-limit-tooltip"
                  />
                </div>
                {/if}

              {#if datasetMetadata.bulkdownload}
                <div class="p-2 d-flex flex-row align-items-center">
                  <div class="dropdown">
                    <button
                      class="btn ae-tertiary dropdown-toggle me-1"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="bi bi-download"></i>
                      Bulk Download
                    </button>
                    <ul class="dropdown-menu">
                      {#each datasetMetadata.ncei.links.access.filter((a) => a.type === "download") as a}
                        <li><a class="dropdown-item" href={a.url}>{a.name}</a></li>
                      {/each}
                    </ul>
                  </div>
                  <TooltipHybridButton
                    searchUrlQueryParam="bulk-download"
                    tooltip="View all the files for this dataset and download them without having to
                        place orders."
                  />
                </div>
              {/if}
            </div>

            <!-- Dataset Cards -->
            <div class="row">
              <div class="col">
                <DataSearchResults {searchResponse} {datasetMetadata} />

                <!-- Pagination -->
                {#if searchResponse?.aggs?.count}
                  <div class="row">
                    <div class="col">
                      <Pageination pageSize={PAGE_SIZE} count={searchResponse?.aggs?.count} />
                    </div>
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      {:catch error}
        <div id="error-container">
          <div id="error-card">
            <p class="custom-error-message">
              Something went wrong
              <br />
              {error}
            </p>
          </div>
        </div>
      {/await}

      <!-- Success Notification (always in DOM) -->
      <CartNotification />

      <!-- Cart alert (conditionally shown) -->
      {#if $fileStore.selectedFiles.length > 0 && $showCartAlert}
        <CartAlert {datasetMetadata} />
      {/if}

      <!-- Modal -->
      <OrderOptionsModal selectedFileList={$fileStore.selectedFiles} {datasetMetadata} />
    </main>
  </div>
</div>

<style>
    #error-container {
        height: 45vh;
    }

    #error-card {
        display: flex;
        width: 45%;
        background-color: #e7b1b6;
        margin: 3vh auto;
        border-radius: 2vh;
        padding: 2vh;
    }

    #error-container #error-card .custom-error-message {
        font-size: clamp(1rem, 2vw, 1.5rem);
        margin: auto;
    }

    .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
        width: 100%;
    }
</style>
